import _ from "lodash";
import { dateFormatter } from "@/use/utilities/time/dateFormatter";
import { useStore } from "vuex";

export function useMessageTransform() {
  const store = useStore();

  const renderMessage = (string) => {
    return string.replace(String.fromCharCode(92), String.fromCharCode('', ''));
  };

  const getThumbnails = (message) => {
    let urls = [];
    message.media.forEach((singleMedia) => {
      urls.push(singleMedia.temporary_url);
    });
    return urls;
  };

  const transformDataMessage = (message) => {
    return {
      first_name: message.user.first_name,
      last_name: message.user.last_name,
      channel_message_type: message.message_type.slug,
      channel_message_color: message.message_type.color,
      is_sender: (store.state.user.id === message.user_id),
      time: dateFormatter(message.created_at, { onlyTime: true }),
      text: renderMessage(message.body),
      attachments: getThumbnails(message),
      role: message?.user_role?.name,
    };
  };

  const groupMessagesByDate = (messages) => {
    return _(messages)
      .map((value) => {
        let msg = transformDataMessage(value);
        return {
          ...msg,
          date: dateFormatter(value.created_at, { onlyDate: true }),
        };
      })
      .groupBy('date')
      .map((value, key) => ({
        date: key,
        messages: _.chain(value)
          .sortBy('created_at')
          .value()
          .reverse()
      }))
      .value()
      .reverse();
  };

  return {
    transformDataMessage,
    groupMessagesByDate,
  };
}

